import React, {useState} from 'react';
import { 
  ButtonStartStyles, 
  DivStyles, 
  InputStyles,
  TextStyles,
} from '../../../../SharedStyles';

const ChargerButton = (props) => {
  // console.log('BUTTON PROPS', props);
  const handleChange = (e) => {
    props.handleSelections(e.target.name, e.target.value);
  };  

  return (
    <DivStyles
        align='center'
        size='14px'
        padding='10px 0'
        display='flex'
        alignItems='center'
        justifyContent='center'>
      {props.isAdminUser && (
      <DivStyles
        align='center'
        size='14px'
        padding='10px 0'
        display='flex'
        alignItems='center'
        justifyContent='center'>
        <DivStyles margin='0 10px' display='flex' alignItems='center'>     
          <TextStyles margin='5px 0 0' whiteSpace='nowrap'>Driver Id Tag: </TextStyles> 
          <InputStyles
            width='auto'
            margin='0 0 0 10px'
            type='text'
            name='idTag'
            placeholder='Driver Id Tag'
            value={props.idTag || ''}
            onChange={handleChange}
            required
          />
        </DivStyles>
      </DivStyles>        
      )}
      <DivStyles>
        <ButtonStartStyles
          flex='1'
          maxWidth='230px'
          fontSize='16px'
          fontWeight='600'
          bgColor='#ff8f45'
          hoverBg='#ff7317'
          color='#fff'
          hoverColor='#fff'
          border='1px solid #ff8f45'
          margin='0 0 2%'
          padding='6px 10px'
          onClick={() => props.handleStartStop()}
          disabled={props.disabled}>
          {props.buttonText}          
        </ButtonStartStyles>
      </DivStyles>
    </DivStyles>
  );
};

export default ChargerButton;
